import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=65438184&"
import script from "./BaseLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports